import { SegmentedControl, SegmentedControlProps, rem } from '@mantine/core';
import cn from 'clsx';

export function FilterButtons({
  data,
  value,
  compact,
  onChange,
  segControlProps,
}: {
  data: SegmentedControlProps['data'];
  value: SegmentedControlProps['value'];
  compact?: boolean;
  onChange: SegmentedControlProps['onChange'];
  segControlProps?: Partial<SegmentedControlProps>;
}) {
  if (data.length <= 1) {
    return null;
  }

  return (
    <SegmentedControl
      withItemsBorders={false}
      {...segControlProps}
      data={data}
      value={value}
      onChange={onChange}
      styles={{
        root: {
          outline: 'none',
          background: 'transparent',
          gap: rem(16),
          height: compact ? rem(32) : rem(48),
          overflow: 'visible',
        },
        indicator: { display: 'none' },
      }}
      classNames={{
        label: cn(
          compact
            ? 'px-6 rounded-[8px] !leading-8 text-xs'
            : 'px-9 rounded-[100px] !leading-[3rem] text-sm',
          'outline-[1px] outline outline-white/[0.14]',
          'font-[700]',
          'transition-colors data-[active]:bg-primarypurple/10 data-[active]:outline-primarypurple hover:outline-primarypurple'
        ),
      }}
    />
  );
}
